import { Component, Inject, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { customValidator } from 'src/app/shared/validators/fields-validators';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-edit-product-inventory',
  templateUrl: './edit-product-inventory.component.html',
  styleUrls: ['./edit-product-inventory.component.scss']
})
export class EditProductInventoryComponent implements OnInit {
  isDisabled = environment.BASE_URL_API.includes('stareuropa');
  form!: FormGroup;
  generalRulesform!: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<EditProductInventoryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
  ) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      sku: [this.data?.sku ?? '', Validators.required],
      barcodeControl: [this.data?.barcodeControl ?? ''],
      quantity: [
      { value: this.data?.quantity ?? '', disabled: this.isDisabled },
      [Validators.max(9999999999) ,Validators.min(0)]
    ],
        reorder_point: [
      this.data?.reorder_point ?? '',
      [Validators.max(9999999999) ,Validators.min(0)]
    ],
      codes: this.fb.array([]),
      expiry_date: [this.data?.expiry_date ?? ''],
    });
    this.initializeCodes(this.data.codes);

    this.generalRulesform = this.fb.group({
      max_qte: [this.data?.max_qte ?? null],
      min_qte: [this.data?.min_qte ?? null],
      increment: [this.data?.increment ?? null],
    }, {
      validators: customValidator(this.data.translate)
    });
  }

  preventMinus(event: KeyboardEvent) {
    if (event.key === '-' || event.key === '+') {
      event.preventDefault();
    }
  }

  get codes(): FormArray {
    return this.form.get('codes') as FormArray;
  }

  initializeCodes(codes: { label: string; value: string }[]): void {
    this.codes.clear();
    codes.forEach((code) => {
      this.codes.push(
        this.fb.group({
          label: [code.label, Validators.required],
          value: [code.value, Validators.required]
        })
      );
    });
  }

  addCode(): void {
    this.codes.push(
      this.fb.group({
        label: ['', Validators.required],
        value: ['', Validators.required]
      })
    );
  }

  removeCode(index: number): void {
    this.codes.removeAt(index);
  }

  sanitize(event: any) {
    event.target.value = event.target.value.replace(/[^\d]/g, '');
  }

  save(): boolean | void {
    const result = {
      ...this.form.value,
      codes: this.codes.value,
      ...this.generalRulesform.value
    }
    if(this.form.invalid){
      this.form.markAllAsTouched()
      return false
    }
    if (this.generalRulesform.invalid) {
      this.generalRulesform.markAllAsTouched()
      return false
    }
    this.dialogRef.close(result)
  }

  closed(){
    this.dialogRef.close()
  }

}
